import { render, staticRenderFns } from "./yearly-sale-item.vue?vue&type=template&id=33829a04&"
import script from "./yearly-sale-item.vue?vue&type=script&lang=js&"
export * from "./yearly-sale-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports